export const INVESTMENT_CHART_TYPES = {
  line: {
    key: "line-chart",
  },
  bar: {
    key: "bar-chart",
  },
};
